import { PaymentProviderName } from 'tm3-core/api.dtos';
import EConfigKeys from 'tm3-core/enums/config-enum';
import FeatureEnum from 'tm3-core/enums/feature-enum';
import type IFeature from 'tm3-core/interfaces/feature';
import ModuleEnum from 'tm3-core/licence';

class Features {
  public static Stripe: IFeature = {
    flags: [],
    config: {
      [EConfigKeys.TM3_PAYMENTS_MERCHANT]: PaymentProviderName.Stripe,
      [EConfigKeys.TM3_PAYMENTS_ENABLE_TM3]: 'TRUE'
    },
    modules: [ModuleEnum.CardPayments]
  };

  public static StripeTerminal: IFeature = {
    flags: [FeatureEnum.FF_TM3_STRIPE_TERMINALS],
    config: {
      [EConfigKeys.TM3_PAYMENTS_MERCHANT]: PaymentProviderName.Stripe,
      [EConfigKeys.TM3_PAYMENTS_ENABLE_TM3]: 'TRUE'
    },
    modules: [ModuleEnum.CardPayments, ModuleEnum.StripeTerminals]
  };

  public static Worldpay: IFeature = {
    flags: [FeatureEnum.TM3_PAYMENTS],
    config: {
      [EConfigKeys.TM3_PAYMENTS_MERCHANT]: PaymentProviderName.Worldpay,
      [EConfigKeys.TM3_PAYMENTS_ENABLE_TM3]: 'TRUE'
    }
  };

  public static Square: IFeature = {
    flags: [FeatureEnum.SQUARE],
    config: {
      [EConfigKeys.TM3_PAYMENTS_MERCHANT]: PaymentProviderName.Square,
      [EConfigKeys.TM3_PAYMENTS_ENABLE_TM3]: 'TRUE',
      [EConfigKeys.SQUARE_AVAILABLE]: 'TRUE'
    },
    modules: [ModuleEnum.CardPayments]
  };
  // not very DRY but the auth screen should be shown regardless hence I think these need to be separate
  public static SquareAuthenticated: IFeature = {
    flags: [FeatureEnum.SQUARE],
    config: {
      [EConfigKeys.TM3_PAYMENTS_MERCHANT]: PaymentProviderName.Square,
      [EConfigKeys.TM3_PAYMENTS_ENABLE_TM3]: 'TRUE',
      [EConfigKeys.SQUARE_AUTHENTICATED]: 'TRUE',
      [EConfigKeys.SQUARE_AVAILABLE]: 'TRUE'
    }
  };

  public static SquareTerminal: IFeature = {
    flags: [FeatureEnum.SQUARE, FeatureEnum.SQUARE_TERMINALS_ENABLED],
    config: {
      [EConfigKeys.TM3_PAYMENTS_MERCHANT]: PaymentProviderName.Square,
      [EConfigKeys.TM3_PAYMENTS_ENABLE_TM3]: 'TRUE',
      [EConfigKeys.SQUARE_AUTHENTICATED]: 'TRUE',
      [EConfigKeys.SQUARE_AVAILABLE]: 'TRUE'
    },
    modules: [ModuleEnum.CardPayments]
  };

  public static Medipass: IFeature = {
    flags: [FeatureEnum.MEDIPASS_ACTIVE],
    config: {
      [EConfigKeys.MEDIPASS_ENABLED]: 'TRUE'
    }
  };

  public static ClearAccept: IFeature = {
    flags: [],
    config: {
      [EConfigKeys.TM3_PAYMENTS_MERCHANT]: PaymentProviderName.ClearAccept,
      [EConfigKeys.TM3_PAYMENTS_ENABLE_TM3]: 'TRUE',
      [EConfigKeys.CLEAR_ACCEPT_AVAILABLE]: 'TRUE'
    },
    modules: [ModuleEnum.CardPayments]
  };

  public static ClickClearAcceptTerminal: IFeature = {
    flags: [],
    config: {
      [EConfigKeys.TM3_PAYMENTS_MERCHANT]: PaymentProviderName.ClearAccept,
      [EConfigKeys.TM3_PAYMENTS_ENABLE_TM3]: 'TRUE',
      [EConfigKeys.CLEAR_ACCEPT_AVAILABLE]: 'TRUE'
    }
  };

  public static ClearAcceptTerminal: IFeature = {
    flags: [],
    config: {
      [EConfigKeys.TM3_PAYMENTS_MERCHANT]: PaymentProviderName.ClearAccept,
      [EConfigKeys.TM3_PAYMENTS_ENABLE_TM3]: 'TRUE',
      [EConfigKeys.CLEAR_ACCEPT_AVAILABLE]: 'TRUE'
    },
    modules: [ModuleEnum.CardPayments]
  };
}

export default Features;
